module.exports = __webpack_public_path__ + "img/group-13_2@3x.ccef1aa3.png";